import React from 'react';
import { Layout, Typography, Space } from 'antd';
import { Link } from 'react-router-dom';

const { Footer: AntFooter } = Layout;
const { Text } = Typography;

export const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <AntFooter style={{
      textAlign: 'center',
      background: '#001529',
      color: 'rgba(255, 255, 255, 0.85)',
      padding: '24px 50px',
    }}>
      <Space direction="vertical" size="small">
        <Space split={<span style={{ color: 'rgba(255,255,255,0.4)' }}>|</span>}>
          <Text style={{ color: 'rgba(255, 255, 255, 0.85)' }}>
            © {currentYear} Система управления турнирами по карате
          </Text>
          <Link to="/docs" style={{ color: 'rgba(255, 255, 255, 0.85)' }}>
            Документация
          </Link>
          <Link to="/privacy-policy" style={{ color: 'rgba(255, 255, 255, 0.85)' }}>
            Политика конфиденциальности
          </Link>
        </Space>
        <Text style={{ color: 'rgba(255, 255, 255, 0.65)', fontSize: '12px' }}>
          Все права защищены
        </Text>
      </Space>
    </AntFooter>
  );
};

export default Footer;
